module.exports = __webpack_public_path__ + "img/cd.242e0ca5.svg";